const DrugType = {
    RAPID_SEQUENCE: 1,
    MAINTENANCE: 2,
    VASOACTIVE: 3,
}

export default DrugType;